import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Paper,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import React, { useEffect, useRef, useState } from 'react'
import { getApiDataProgressPayment, liveUrl } from '../APIHelper'
import { isArray, isEmpty, isUndefined } from 'lodash'
import CardDetails from '../CardDetails'
import PaymentStatus from '../PaymentStatus'
import { loadStripe } from '@stripe/stripe-js'
import useStyles from './styles'
import { Elements } from '@stripe/react-stripe-js'
import { useTheme } from '@emotion/react'
import { Strings } from '../../Strings'
import { capitalizeWordFirstLetter, checkNull, convertIntervalTypeWithGateway, redirectToUrl } from '../../Helpers'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import { currency_symbol as symbol } from '../staticData'
import PricingBreakdown from '../PricingBreakdown'
import { BrandHeader, PoweredBy, applyBackendBranding, getBranding } from '../Branding'
import CheckoutSkeleton from '../CheckoutSkeleton'
import AautiPayLoader from '../AautiPayLoader'

/**
 * PaymentAggregator component for handling various payment methods and aggregating them.
 *
 * @component
 * @param {Object} props - Component properties.
 * @returns {JSX.Element} - React JSX element representing the PaymentAggregator component.
 */
const PaymentAggregator = (props) => {
  const [paySuccess, setPaySuccess] = useState(false)
  const theme = useTheme()
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const lg = useMediaQuery(theme.breakpoints.down('lg'))
  const currentDomain = window.location
  const [gatewayName, setGatewayName] = useState('')
  const [merchantName, setMerchantName] = useState('')
  const [merchantLogo, setMerchantLogo] = useState('')
  const [productDetails, setProductDetails] = useState([])

  const {
    PaymentType = '', //require => one_time, subscription, custom_subscription
    paymentData = {
      name: 'Ronak',
      amount: 50,
      email: '',
      country_code: 'IN',
      toCountryCode: 'IN',
      address: "",
      app_token:
        'app_5B7768DA83B0AE019F437C0CCD61C5EE52A9ED60F3A566EBE1F286009B61',
      currency: 'INR',
      transaction_code: 'txn_1234567',
      mobile: '8008996001',
      payThroughEMI: false,
      payThroughRecurrence: false,
      updateSubscription: false, //for update subscription like cancel,pause,resume,update payment Method,
      //for razorpay there is no update payment method
      updateSubscriptionType: 'paymentMethod', //cancel,pause,resume,paymentMethod (required if updateSubscription=true)
      recurrenceObj: {
        intervalType: 'monthly', //weekly,monthly,yearly
        //default is 1
        interval_count: 1, //if interval_count=2 then it is for every 2 (months,week,year)
        //default is 0 means forever
        iterations: 0, //if suppose iteration is 2 then it will charge 2 (months,week,year)
        start_at: '', //in local date time format for future subscription schedule
        order_code: '08D2665B0B8B0BB104845056E7B12911F29573259DE8156338', //required for update payment method
      },
    }, //require
    // onPaymentDone = () => {
    //   // setTimeout(() => setPaySuccess(false), 3000)
    // },
    onCloseClick = () => { },
    // tells the parent (HomePage) about the branding returned by login
    onBrandingLoaded,
    appCharges = [
    ],
    noCharge = false,
    pluginURL = 'staging', //staging, dev, prodapi
    changeBtnText: changeBtnTextProp,
    showHeader = true,

    // For gradient
    isGradientButton = true,
    linearColorsName = ['#0BBCED', '#1252A5'],
  } = props
  // branding saved in the AautiPay portal, returned by login; wins over props
  const [backendBranding, setBackendBranding] = useState(null)
  // primaryColor, themeColor, headerText, headerColor, headerTextColor, loaderColor
  const brand = getBranding(applyBackendBranding(props, backendBranding))
  const { primaryColor, themeColor } = brand
  
console.log('props----->', paymentData?.isWebview)

  const hideAmount = paymentData?.updateSubscription && !paymentData?.payThroughRecurrence
  // a plain "Pay" is the generic label, not a custom one, so subscriptions
  // and updates still get "Subscribe" / "Update"
  const hasCustomBtnText = !isEmpty(changeBtnTextProp?.trim?.()) && changeBtnTextProp.trim().toLowerCase() !== 'pay'
  const changeBtnText = hasCustomBtnText
    ? changeBtnTextProp
    : hideAmount
      ? 'Update'
      : paymentData?.payThroughRecurrence
        ? 'Subscribe'
        : 'Pay'

  let params = new URL(document.location.toString()).searchParams
  let isMobile = params.get('isMobile')
  let pl_code = params.get('payment_link_id') || props?.pl_code || null
  const isHeaderShown = showHeader && !isMobile
  const styles = useStyles()

  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISH_KEY
  )
  const paymentId = useRef(null)
  const paymentPopupRef = useRef(null)

  const [failMessage, setFailMessage] = useState('')
  const [hasPopup, setHasPopup] = useState(false)
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false)
  const [hideFailActions, setHideFailActions] = useState(false)

  const [pageLoade, setPageLoader] = useState(true)
  const [chargeData, setChargeData] = useState({})

  const [activeIndex, setActiveIndex] = useState([])
  const [paymentMethod, setPaymentMethod] = useState([])
  const [achData, setAchData] = useState({
    redirect_ach_url: '',
    trans_code: '',
    payType: '',
  })
  const [paymentRegionId, setPaymentRegionId] = useState({
    currency_id: '',
    country_id: '',
    currency_symbol: '',
  })
  const [currencyData, setCurrencyData] = useState(symbol)
  const [cashfree, setCashfree] = useState(null);


  const isCard = paymentMethod?.filter(
    (item) => item?.type === 'card' && !isEmpty(item?.charge_object)
  )
  const isBank = paymentMethod?.filter(
    (item) => item?.type === 'bank' && !isEmpty(item?.charge_object)
  )
  const isOther = paymentMethod?.filter(
    (item) =>
      item?.type === 'digital wallet' &&
      !isEmpty(item?.charge_object) &&
      item['payment_method.payment_method'] !== 'Apple Pay' &&
      item['payment_method.payment_method'] !== 'Google Pay'
  )

  const [paymentSelectedType, setPaymentSelectedType] = useState('')

  const isRecurring =
    paymentData?.payThroughRecurrence ||
    paymentData?.payThroughEMI ||
    paymentData?.updateSubscription

  const isForUpdatePayDetails = paymentData?.updateSubscription
    ? [Strings.cancel, Strings.pause, Strings.resume]?.includes(
      paymentData?.updateSubscriptionType
    )
      ? true
      : false
    : false

  const isIndianPayment = paymentData?.country_code === 'IN' ? true : false

  const isRazorpayGateway = gatewayName === 'razorpay'

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(false)
      }
      document.body.appendChild(script)
    })
  }

  // merchant redirect_url from the payment link API
  const redirectUrl = props?.redirect_url

  const onPaymentDone = (payload = 'success') => {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage((payload));
    } else {
      console.warn("Not inside a WebView context");
    }
    props?.onPaymentDone?.(payload)
    // payment-link flow only. 'loading' is an in-progress signal, not a final status.
    if (!isEmpty(pl_code) && payload !== 'loading') {
      redirectToUrl(redirectUrl)
    }
  }

  useEffect(() => {
    // Ensure window.Cashfree is available before initializing
    if (window.Cashfree) {
      const cf = window.Cashfree({
        mode: chargeData?.mode == 'live' ? 'production' : "sandbox" // 'production',"sandbox"
      });
      setCashfree(cf);
    } else {
      console.error("Cashfree SDK not loaded. Ensure the script is included.");
    }
  }, [chargeData?.mode]);

  const loadRazorpay = async (amount, id) => {
    let { email, mobile, name } = paymentData
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
    let msg = ''
    if (!res) {
      console.log('Razorpay SDK failed to load. Are you online?')
      setPaySuccess('fail')
      setFailMessage('Authentication Failed')
    }
    const options = {
      key: process.env.REACT_APP_KEY, // Replace with your Razorpay key
      amount: amount * 100, // Amount is in paise, so this is 50000 paise or ₹500
      currency: 'INR',
      handler: function (response) {
        setPaySuccess(msg)
        onPaymentDone()
        // You can send the payment ID to your server for verification here
      },
      modal: {
        confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.
        // This function is executed when checkout modal is closed
        // There can be 3 reasons when this modal is closed.
        ondismiss: async (reason) => {
          let status =
            !paymentData?.payThroughRecurrence &&
              !paymentData?.updateSubscription
              ? 'fail'
              : paymentData?.updateSubscription
                ? Strings.updateFailed
                : 'Subscription Pending'
          // Reason 1 - when payment is cancelled. It can happend when we click cross icon or cancel any payment explicitly.
          if (reason === undefined) {
            setPaySuccess(status)
            setFailMessage('Payment processing cancelled by user')
          }
          // Reason 2 - When modal is auto closed because of time out
          else if (reason === 'timeout') {
            setPaySuccess(status)
            setFailMessage(reason)
          }
          // Reason 3 - When payment gets failed.
          else {
            setPaySuccess(status)
            setFailMessage(reason?.error?.description)
          }
        },
      },
      prefill: {
        email: email,
        contact: mobile,
        name: name,
      },
      retry: {
        enabled: true,
      },
    }
    if (
      !paymentData?.payThroughRecurrence &&
      !paymentData?.updateSubscription
    ) {
      options.order_id = id
      msg = 'success'
    } else if (
      paymentData?.payThroughRecurrence &&
      !paymentData?.updateSubscription
    ) {
      options.subscription_id = id
      msg = Strings.subscriptionSuccess
    } else if (
      paymentData?.updateSubscription &&
      paymentData?.updateSubscriptionType === 'paymentMethod'
    ) {
      options.subscription_id = id
      options.subscription_card_change = true
      msg = Strings.updatePayMethod
    }
    // All information is loaded in options which we will discuss later.
    const rzp1 = new window.Razorpay(options)

    // If you want to retreive the chosen payment method.
    rzp1.on('payment.submit', (response) => {
      paymentMethod.current = response.method
    })

    // To get payment id in case of failed transaction.
    rzp1.on('payment.failed', (response) => {
      paymentId.current = response.error.metadata.payment_id
    })

    // to open razorpay checkout modal.
    rzp1.open()
  }

  const changePayMethod = async () => {
    if (
      paymentData?.updateSubscription &&
      isIndianPayment &&
      paymentData?.updateSubscriptionType === Strings.paymentMethod
    ) {
      setPaySuccess('loading')
      onPaymentDone('loading')
      const getDetails = await checkPaymentProgress(
        paymentData?.recurrenceObj?.order_code,
        true
      )
      if (!checkNull(getDetails) && Object.keys(getDetails)?.length > 0) {
        loadRazorpay(getDetails?.charged_amount, getDetails?.subscription_id)
      } else {
        setPaySuccess('fail')
        setFailMessage('Authentication failed')
      }
    }
  }

  async function getCurrency() {
    setPageLoader(true)
    try {
      const response = await getApiDataProgressPayment(
        `${liveUrl}getAllCurrencySymbol`,
        'GET'
      )
      if (response?.status == false) {
        // setPageLoader(false)
      } else {
        setCurrencyData(
          !checkNull(response?.data) && Object.keys(response?.data)?.length > 0
            ? response?.data
            : symbol
        )
      }
    } catch (error) {
      console.log('error:', error)
    }
    getAccessToken()
  }
  const getProductDetails = async () => {
    const response = await getApiDataProgressPayment(
      `${liveUrl}getProductDetails/${paymentData?.app_token}`,
      'GET'
    )
    if (response?.status == false) {
      // setPageLoader(false)
    } else {
      setProductDetails(response?.data)
    }
  }

  useEffect(() => {
    setCurrencyData(symbol)
    getCurrency()
    setFailMessage('')
    getProductDetails()
    // keyed on the payment, not the props object: memo can still hand this a fresh
    // props object on re-render, which re-ran login and saved the order twice
  }, [paymentData?.app_token, paymentData?.transaction_code])

  useEffect(() => {
    isEmpty(paymentSelectedType) &&
      setPaymentSelectedType(
        !isEmpty(isOther)
          ? 'digital wallet'
          : !isEmpty(isBank)
            ? 'bank'
            : 'card'
      )
  }, [isOther, isCard])

  const iframe = document.getElementById('myIframe')
  useEffect(() => {
    if (iframe) {
      // Listen for the iframe's load event
      iframe.addEventListener('load', function () {
        // Access the iframe's contentWindow and its location object
        const iframeContentWindow = iframe.contentWindow
        const url = iframeContentWindow.location.href
        var regex = /[?&]([^=#]+)=([^&#]*)/g,
          params = {},
          match
        while (!isEmpty(url) && (match = regex.exec(url))) {
          params[match[1]] = match[2]
        }
        if (url.includes('payment_intent')) {
          checkStripePayment(url)
        } else if (url.includes('success')) {
          setPaySuccess('success')
          onPaymentDone()
          // Close the InAppBrowser
        } else if (url.includes('failure')) {
          setPaySuccess('fail')
          let msg = params?.message ?? ''
          // let message = msg?.replace(/%20/g, ' ')
          let message = decodeURIComponent(decodeURIComponent(msg))
          setFailMessage(message ?? 'Authentication failed')
          setTimeout(() => {
            setPaySuccess(false)
          }, 5000)
        } else if (url.includes('cancel')) {
          setPaySuccess('cancel')
          let msg = params?.message ?? ''
          // let message = msg?.replace(/%20/g, ' ')
          let message = decodeURIComponent(decodeURIComponent(msg))
          setFailMessage(message ?? 'Payment Cancelled')
          setTimeout(() => {
            setPaySuccess(false)
          }, 5000)
        } else if (url.includes('setup_intent')) {
          checkStripSetupIntent(url)
        }

        // if (url) {
        //   setFailMessage('')
        // }
      })
    }
  }, [iframe])

  // Async function for checking the status of a Stripe payment
  /**
   * Check the status of a Stripe payment using the provided URL.
   *
   * @async
   * @function
   * @param {string} url - The URL containing payment information.
   * @returns {Promise<void>} - A Promise that resolves once the payment status is checked.
   */
  async function checkStripePayment(url) {
    // Regular expression to extract query parameters from the provided URL
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
      params = {},
      match
    // Loop through the URL and extract query parameters
    while (!isEmpty(url) && (match = regex.exec(url))) {
      params[match[1]] = match[2]
    }
    // Retrieve the Stripe secret key from the extracted parameters
    const stripeSecretKey = params?.key

    // Make a GET request to the Stripe API to retrieve payment intent information
    fetch(
      `https://api.stripe.com/v1/payment_intents/${params?.payment_intent}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${stripeSecretKey}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // Check if the payment status is "succeeded"
        if (data?.status == 'succeeded') {
          // Set payment success status to "success"
          setPaySuccess('success')
          // Call the onPaymentDone function
          onPaymentDone()
        } else if (data?.status == Strings.requires_action) {
          setPaySuccess(Strings.requires_action)
          onPaymentDone()
        } else if (data?.status == 'processing') {
          setPaySuccess(Strings.wait)
          onPaymentDone()
        } else if (data?.status === Strings.requires_payment_method) {
          setPaySuccess('fail')
          setFailMessage(data?.last_payment_error?.message ?? 'Payment Failed!')
          setTimeout(() => {
            setPaySuccess(false)
          }, 5000)
        } else {
          // If payment status is not "succeeded," set payment success status to "fail"
          setPaySuccess(Strings.wait)
          onPaymentDone()
        }
        // Handle the response data here
      })
      .catch((error) => {
        // Handle any errors here
      })
  }

  async function checkStripSetupIntent(url) {
    // Regular expression to extract query parameters from the provided URL
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
      params = {},
      match
    // Loop through the URL and extract query parameters
    while (!isEmpty(url) && (match = regex.exec(url))) {
      params[match[1]] = match[2]
    }
    // Retrieve the Stripe secret key from the extracted parameters
    const stripeSecretKey = params?.key
    const setupIntent = params?.setup_intent

    fetch(
      `https://api.stripe.com/v1/setup_intents/${setupIntent}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${stripeSecretKey}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // Check if the payment status is "succeeded"
        if (data?.status == 'succeeded') {
          // Set payment success status to "success"
          setPaySuccess(Strings.subscriptionSuccess)
          // Call the onPaymentDone function
          onPaymentDone()
        } else if (data?.status == Strings.requires_action) {
          setPaySuccess(Strings.requires_action)
          onPaymentDone()
        } else if (data?.status == 'processing') {
          setPaySuccess(Strings.wait)
          onPaymentDone()
        } else if (data?.status === Strings.requires_payment_method) {
          setPaySuccess('fail')
          setFailMessage(data?.last_setup_error?.message ?? 'Subscription Failed!')
          setTimeout(() => {
            setPaySuccess(false)
          }, 5000)
        } else if (data?.status == 'canceled') {
          setPaySuccess('fail')
          setFailMessage('Payment Canceled')
          setTimeout(() => {
            setPaySuccess(false)
          }, 5000)
        } else if (data?.status == 'requires_confirmation') {
          setPaySuccess(Strings.subPending)
          setFailMessage('Payment Requires Confirmation')
          onPaymentDone()
        }
        else {
          setPaySuccess(Strings.wait)
          onPaymentDone()
        }
        // Handle the response data here
      })
      .catch((error) => {
        // Handle any errors here
      })
  }

  // Asynchronous function to obtain an access token
  /**
   * Asynchronously retrieves an access token from the server for the application.
   *
   * @async
   * @function
   * @returns {Promise<void>} - A Promise that resolves once the access token is obtained.
   */
  async function getAccessToken() {
    // Step 1: Set the page loader to indicate that loading is in progress
    setPageLoader(true)

    // Step 2: Prepare data to be sent in the API request
    const data = {
      app_token: paymentData?.app_token, // Retrieve app token from paymentData
      countryCode: paymentData?.country_code, // Retrieve country code from paymentData
    }

    try {
      // Step 3: Make an asynchronous API request to the login endpoint
      const response = await getApiDataProgressPayment(
        `${liveUrl}login`, // URL for the login endpoint
        'POST', // HTTP method (POST)
        data, // Data to be sent in the request body
        chargeData?.auth_token // Authorization token from chargeData (optional chaining used)
      )
      // Step 4: Check if the API response indicates an error (status is false)
      if (response?.status == false) {
        // Step 5: If an error occurred, set the page loader to false
        setPageLoader(false)
        setPaySuccess('fail')
        setFailMessage(response?.message ?? 'Authentication failed')
      } else {
        // Step 6: If the API response is successful, proceed to handle the data
        if (response?.data) {
          // Step 7: Check if appCharges is not empty, then apply charges
          if (isForUpdatePayDetails) {
            updateSubscriptionDetails(response?.data?.auth_token)
          }
          // !isEmpty(appCharges)
          //   ?
          chargesApply(
            appCharges,
            response?.data?.auth_token,
            response?.data?.userData?.portal_mode
          )
          // : // Step 8: If appCharges is empty, get app charges
          // getAppCharges(
          //   response?.data?.auth_token,
          //   response?.data?.userData?.id,
          //   response?.data?.userData?.portal_mode
          // )
          setGatewayName(response?.data?.userData?.gateway_name)
          if (response?.data?.branding) {
            setBackendBranding(response.data.branding)
            onBrandingLoaded?.(response.data.branding)
          }
          setMerchantName(response?.data?.userData?.name || '')
          setMerchantLogo(response?.data?.userData?.logo || '')
        } else {
          setPaySuccess('fail')
          setFailMessage(response?.message ?? 'Authentication failed')
          setPageLoader(false)
        }
      }
    } catch (error) {
      // Step 9: Handle any errors that occurred during the API request

      // Step 10: Set the page loader to false since an error occurred
      setPageLoader(false)
      console.log('error:', error)
    }
  }

  //update Subscription Details

  async function updateSubscriptionDetails(token) {
    let apiUrl = ``
    switch (paymentData?.updateSubscriptionType) {
      case Strings.pause:
        apiUrl = `${liveUrl}pause-subscription-payment`
        break
      case Strings.resume:
        apiUrl = `${liveUrl}resume-subscription-payment`
        break
      case Strings.cancel:
        apiUrl = `${liveUrl}cancel-subscription-payment`
        break
      default:
        break
    }
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        order_code: paymentData?.recurrenceObj?.order_code,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status) {
          setPageLoader(false)
          setPaySuccess(Strings?.updatePayMethod)
          setFailMessage(data?.message)
          onPaymentDone()
        } else {
          setPageLoader(false)
          setPaySuccess(
            `${capitalizeWordFirstLetter(
              paymentData?.updateSubscriptionType
            )} Failed`
          )
          setFailMessage(data?.message ?? 'Something went wrong!')
        }
        // Handle the response data here
      })
      .catch((error) => {
        // Handle any errors here
        setPageLoader(false)
      })
  }

  //for razorpay subscription

  async function saveOrder(paymentMethod, chargeData) {
    const gatewayFeeType = noCharge
      ? 'inclusive'
      : chargeData?.isPaymentGateWay
        ? 'exclusive'
        : 'inclusive'
    setPaySuccess('loading')
    setHideFailActions(false)
    onPaymentDone('loading')
    const payObj = paymentMethod?.[0]
    try {
      const unit_amount = payObj?.charge_object?.charges_obj?.final_amount

      let amountValue = paymentData?.payThroughEMI
        ? chargeData?.withChargeAmount /
        paymentData?.recurrenceObj?.interval_count
        : chargeData?.withChargeAmount

      let finalAmountValue = paymentData?.payThroughEMI
        ? unit_amount / paymentData?.recurrenceObj?.interval_count
        : unit_amount

      const payableAmount =
        gatewayFeeType === 'exclusive' ? finalAmountValue : amountValue
      let data = {
        name: paymentData?.name,
        amount: amountValue,
        //amount will be split in interval_count if payment is through EMI
        final_amount: finalAmountValue,
        app_token: paymentData?.app_token,
        country_id: payObj?.country_id,
        currency: paymentData?.currency,
        mode: chargeData?.mode,
        payment_method_id: payObj?.payment_method_id,
        payment_sub_method_id: payObj?.payment_sub_method_id,
        transaction_code: paymentData?.transaction_code,
        gateway_code: payObj?.charge_object?.gateway_code,
        gateway_id: payObj?.gateway_id,
        payment_gateway_fee: gatewayFeeType,
        email: paymentData?.email,
        base_amount: paymentData?.amount,
        charge_id: payObj?.charge_object?.charges_obj?.id,
        platform: 'web',
        charges_json: JSON.stringify(chargeData?.mainChargeData),
        mobile: paymentData?.mobile,
        is_subscription: isRecurring,
        chargeAsFixedAmount: paymentData?.chargeAsFixedAmount,
        order_details: props?.order_details || paymentData?.order_details,
        address: paymentData?.address,
        to_country_code: paymentData?.toCountryCode,
        pl_code: pl_code,
      }

      if (isRecurring) {
        let details = paymentData?.recurrenceObj
        let intervalType = details?.intervalType
        data.recurring_details = JSON.stringify({
          interval: convertIntervalTypeWithGateway(isIndianPayment ? isRazorpayGateway ? 'razorpay' : 'cashfree' : 'stripe', intervalType),
          interval_count: checkNull(details?.interval_count)
            ? 1
            : details?.interval_count,
          maxRecurrenceAmount: details?.maxRecurrenceAmount
        })
        !checkNull(details?.start_at) &&
          (data.start_date = moment(details?.start_at).unix())
        !checkNull(details?.end_at) &&
          (data.end_date = moment(details?.end_at)
            .unix())
        data.iterations =
          checkNull(details?.iterations) || details?.iterations <= 0
            ? intervalType === 'monthly'
              ? 360
              : intervalType === 'yearly'
                ? 30
                : intervalType === 'weekly'
                  ? 1565
                  : 0
            : details?.iterations
      }
      const response = await getApiDataProgressPayment(
        `${liveUrl}save-order`,
        'POST',
        JSON.stringify(data),
        chargeData?.auth_token
      )
      if (response?.status == false) {
        setPaySuccess('fail')
        setFailMessage(response?.message)
        onPaymentDone('fail')
      } else if (isIndianPayment && !isRecurring) {
        paymentApi(payObj, response?.code, chargeData, payableAmount)
      } else {
        subscriptionApi(
          1,
          response?.code,
          paymentMethod,
          chargeData,
          payableAmount
        )
      }
    } catch (error) {
      console.log('error:', error)
      setPaySuccess('fail')
      setFailMessage('Authentication failed')
    }
  }

  const getPaymentStatus = async (orderId) => {
    fetch(
      `${liveUrl}get-cf-order-by-id/${orderId}`,
      {
        method: 'GET',
      }
    )
      .then((response) => response.json())
      .then((response) => {
        const res = response?.data
        console.log('response check from api', res?.order_status, res)
        if (response?.status === true) {
          if (res?.order_status === 'PAID') {
            setPaySuccess('success')
            onPaymentDone()
          }
          else if (res?.order_status === 'PENDING') {
            setPaySuccess('pending')
            setFailMessage('Payment Pending')
            onPaymentDone()
          } else if (res?.order_status === 'ACTIVE') {
            setPaySuccess(Strings.cancel)
            setFailMessage('User cancelled the transaction')
          } else {
            setPaySuccess(Strings.wait)
            onPaymentDone()
          }
        } else {
          setPaySuccess(Strings.wait)
          onPaymentDone()
        }
      })
      .catch((err) => {
        setPaySuccess(Strings.wait)
        onPaymentDone()
      })
  }

  const cashFreePayment = (resData, chargeDataParam) => {
    // Use existing cashfree instance or initialize on-the-fly if not ready yet
    const cd = chargeDataParam || chargeData
    console.log('Cashfree payment initiated with charge data:', cd)
    let cf = cashfree
    if (!cf) {
      if (window.Cashfree) {
        cf = window.Cashfree({
          mode: cd?.mode == 'live' ? 'production' : 'sandbox'
        })
        setCashfree(cf)
      } else {
        console.error("Cashfree SDK not loaded. Ensure the script is included.")
        return
      }
    }
    const { payment_session_id, order_id } = resData;
    const checkoutOptions = {
      paymentSessionId: payment_session_id,
      redirectTarget:paymentData?.isWebview?"_self": "_modal", // _self, '_blank',_modal
    };
    const subscriptionOptions = {
      subsSessionId: payment_session_id,
      redirectTarget: "_self",
    };

    if (isRecurring) {
      cf.subscriptionsCheckout(subscriptionOptions)
    }
    else {
      cf.checkout(checkoutOptions).then((result) => {
        if (result.error) {
          // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
          console.log("User has closed the popup or there is some payment error, Check for Payment Status", result);
          console.log(result.error);
          setPaySuccess("fail");
          setFailMessage(result.error?.message ?? "Payment Failed");
        }
        if (result.redirect) {
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          // This will be called whenever the payment is completed irrespective of transaction status
          console.log("Payment has been completed, Check for Payment Status");
          console.log(result.paymentDetails.paymentMessage);
          // setPaySuccess("success");
          // onPaymentDone()
          getPaymentStatus(order_id)
        }
      })
    }
  }

  async function paymentApi(data, code, chargeData, payableAmount) {
    let final_amount_pay = data?.charge_object?.charges_obj?.final_amount
    let final_data = {
      amount: {
        amount: paymentData?.amount,
        final_amount: final_amount_pay,
      },
    }

    // Encrypt
    let ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(final_data),
      '470cb677d807b1e0017c50b'
    ).toString()

    const Ddata = {
      data: ciphertext,
      order_code: code,
      is_new: 1,
      redirect_url: currentDomain?.origin,
    }

    try {
      const response = await getApiDataProgressPayment(
        `${liveUrl}custom-checkout`,
        'POST',
        JSON.stringify(Ddata),
        chargeData?.auth_token
      )
      if (isUndefined(response) || response?.status === false) {
        setPaySuccess('fail')
        setFailMessage(response?.message?.toString())
      } else {
        if (!checkNull(response?.order_id)) {
          if (isRazorpayGateway) {
            loadRazorpay(payableAmount, response?.order_id)
          } else {
            cashFreePayment(response, chargeData);
          }
        } else {
          setPaySuccess('fail')
        }
      }
    } catch (error) {
      setPaySuccess('fail')
      console.log('error:', error)
    }
  }

  async function subscriptionApi(
    isNew,
    code,
    paymentMethod,
    chargeData,
    payableAmount
  ) {
    const payObj = paymentMethod?.[0]
    let final_pay_amount = payObj?.charge_object?.charges_obj?.final_amount
    let final_data = {
      amount: {
        amount: paymentData?.amount,
        final_amount: final_pay_amount,
      },
    }

    // Encrypt
    let ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(final_data),
      '470cb677d807b1e0017c50b'
    ).toString()
    const Ddata = {
      data: ciphertext,
      order_code: code,
      is_new: isNew,
      remember_me: 0,
      hostName: paymentData.hostName ?? 'aauti-pay',
      type: 'custom_subscription',
      redirect_url: currentDomain?.origin,
    }

    try {
      const response = await getApiDataProgressPayment(
        `${liveUrl}schedule-subscription-payment`,
        'POST',
        JSON.stringify(Ddata),
        chargeData?.auth_token
      )
      if (isUndefined(response) || response?.status === false) {
        setPaySuccess('fail')
        setFailMessage(response?.message?.toString())
        onPaymentDone('fail')
      } else {
        if (!isEmpty(response?.data?.redirect_url) || !isEmpty(response?.data?.subscription_id)) {
          if (isRazorpayGateway) {
            loadRazorpay(payableAmount, response?.data?.subscription_id)
          } else {
            cashFreePayment(response?.data, chargeData);
          }
        } else {
          setPaySuccess('fail')
          onPaymentDone('fail')
        }
      }
    } catch (error) {
      console.log('📌 ⏩ file: index.js:227 ⏩ paymentApi ⏩ error:', error)
    }
  }

  // Function to calculate and process charge-related data
  /**
   * Applies charges to the payment data, calculates amounts, and updates the charge data state.
   *
   * @function
   * @param {Array} mainChargeData - An array containing main charge data.
   * @param {string} token - The authentication token.
   * @param {string} mode - The mode of the charge (e.g., "test" or "production").
   * @returns {void}
   */
  const chargesApply = (mainChargeData, token, mode) => {
    // Initialize variables to store percentage sums for exclusive and inclusive charges
    let sum_per = 0
    let sum_inc_per = 0

    // Filter exclusive charges from mainChargeData
    const filExc = isArray(mainChargeData)
      ? mainChargeData?.filter((V) => V.type === 'exclusive')
      : []

    // Filter inclusive charges from mainChargeData
    const filInc = isArray(mainChargeData)
      ? mainChargeData?.filter((V) => V.type === 'inclusive')
      : []

    // Calculate sum of percentages for exclusive charges excluding "payment_gateway_fee"
    isArray(filExc) &&
      !isEmpty(filExc) &&
      filExc.forEach((v) => {
        if (v.slug !== 'payment_gateway_fee') {
          sum_per = sum_per + v.value
        }
      })
    // Calculate the amount to add based on the sum of exclusive percentages
    const amountToAdd = paymentData?.chargeAsFixedAmount
      ? sum_per
      : (sum_per * paymentData?.amount) / 100

    // Calculate sum of percentages for inclusive charges excluding "payment_gateway_fee"
    isArray(filInc) &&
      !isEmpty(filInc) &&
      filInc.forEach((v) => {
        if (v.slug !== 'payment_gateway_fee') {
          sum_inc_per = sum_inc_per + v.value
        }
      })
    const amountToMin = paymentData?.chargeAsFixedAmount
      ? sum_inc_per
      : (sum_inc_per * paymentData?.amount) / 100

    const isPaymentGateWay =
      isArray(filExc) &&
      !isEmpty(filExc) &&
      filExc.find((v) => v.slug === 'payment_gateway_fee')

    // Construct chargeData1 object with calculated values
    const chargeData1 = {
      isPaymentGateWay: !isEmpty(isPaymentGateWay),
      exclusive_Data: filExc,
      withChargeAmount: paymentData?.amount + amountToAdd,
      withoutChargeAmount: paymentData?.amount - amountToMin,
      auth_token: token,
      mainChargeData: mainChargeData,
      mode: mode,
      amountToAdd: amountToAdd,
    }
    // Set the calculated charge data using the setChargeData function
    setChargeData(chargeData1)
    // Call the getPaymentOption function with the updated token, total amount, and mode
    getPaymentOption(
      token,
      paymentData?.amount + amountToAdd,
      mode,
      chargeData1
    )
  }

  // Asynchronous function to fetch application charges
  /**
   * Fetches application charges from the server, and applies the charges using the chargesApply function.
   *
   * @async
   * @function
   * @param {string} token - The authentication token.
   * @param {string} useID - The user ID.
   * @param {string} mode - The mode of the charge (e.g., "test" or "production").
   * @returns {Promise<void>} A Promise that resolves when the process is complete.
   */
  async function getAppCharges(token, useID, mode) {
    // Make a GET request to the server to fetch application charges
    fetch(`${liveUrl}get-app-charges/${useID}/${paymentData?.country_code}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json()) // Parse the response as JSON
      .then((data) => {
        // Check if the API response indicates success (status is true)
        if (data?.status) {
          // Apply charges using the chargesApply function with the fetched data
          chargesApply(data?.data, token, mode)
        } else {
          // If the response indicates an error, set the page loader to false
          setPageLoader(false)
        }
        // Handle the response data here
      })
      .catch((error) => {
        // Handle any errors here
        setPageLoader(false)
      })
  }

  // Function to fetch payment options
  /**
   * Fetches payment options from the server based on the provided parameters,
   * and updates the payment methods, active index, and page loader state accordingly.
   *
   * @param {string} auth_token - The authentication token.
   * @param {number} amountToAdd - The amount to add (considering additional charges).
   * @param {string} mode - The mode of the charge (e.g., "test" or "production").
   * @returns {void}
   */
  const getPaymentOption = (auth_token, amountToAdd, mode, chargeData1) => {
    try {
      // Make a GET request to the server to fetch payment options
      fetch(
        `${liveUrl}payment-options/${paymentData.country_code
        }?method=${''}&mode=${mode}&amount=${noCharge ? paymentData?.amount : amountToAdd
        }&currency=${paymentData?.currency}&reccurance=${isRecurring}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${auth_token}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          // Check if the API response indicates success (status is true)
          if (response?.status) {
            setPaymentRegionId({
              currency_id: response?.currency_id,
              country_id: response?.country_id,
              currency_symbol: response?.currency_symbol,
            })
            // Set payment methods using the setPaymentMethod function
            setPaymentMethod(response?.data)
            // Set the active index based on the minimum index from the response
            setActiveIndex(response?.minimum_index)
            // Set the page loader to false since the operation is complete
            setPageLoader(false)
            if (isRecurring && paymentData?.updateSubscription) {
              changePayMethod()
            } else if (isIndianPayment && !pl_code && !paymentData?.updateSubscription) {
              // Normal Indian payment (with id param) — auto save-order and checkout
              saveOrder(response?.data, chargeData1)
            }
          } else {
            // Handle cases where the response indicates an error

            // Check for specific unauthorized error
            if (
              response?.statusCode === 401 &&
              response?.message ===
              'Unauthorized. Access token is missing or invalid.'
            ) {
            }
            // Set the page loader to false since an error occurred
            setPaySuccess('fail')
            setFailMessage(response?.message)
            setPageLoader(false)
          }
        })
        .catch((err) => {
          // Handle any errors that occurred during the API request
          console.log('err.message', err.message)
          // Set the page loader to false since an error occurred
          setPageLoader(false)
        })
    } catch (error) {
      setPageLoader(false)
      console.log('ERRRRR', error)
    }
  }

  const checkPaymentProgress = async (code, sendId = false) => {
    return fetch(
      `${liveUrl}pay-response/pay-in/${code}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${chargeData?.auth_token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (sendId) {
          return response?.data
        } else {
          setAchData((prev) => ({ ...prev, trans_code: '' }))
          if (response?.data?.status == 'success') {
            setPaySuccess('success')
            onPaymentDone()
          } else if (response?.data?.status == 'processing') {
            setPaySuccess(Strings.wait)
            setFailMessage(response?.data?.message)
            onPaymentDone()
            setTimeout(() => {
              setPaySuccess(false)
            }, 5000)
          } else if (response?.data?.status == 'failed') {
            setPaySuccess('fail')
            setFailMessage(response?.data?.message)
            setTimeout(() => {
              setPaySuccess(false)
            }, 5000)
          } else if (response?.data?.status == Strings.requires_action) {
            setPaySuccess(Strings.requires_action)
            onPaymentDone()
          } else if (response?.data?.status == 'initialized' || response?.data?.status == "pending") {
            setPaySuccess('cancel')
            setFailMessage('Payment Cancelled')
            setTimeout(() => {
              setPaySuccess(false)
            }, 5000)
          } else if (response?.data?.status == 'subscription authenticated' || response?.data?.status == 'subscription created') {
            setPaySuccess(Strings.subscriptionSuccess)
            onPaymentDone()
          }
          else {
            setPaySuccess(
              response?.data?.status !== undefined &&
                response?.data?.status !== null
                ? response?.data?.status
                : 'fail'
            )
            setFailMessage(
              response?.data?.message !== undefined &&
                response?.data?.message !== null
                ? response?.data?.message
                : 'Payment Cancelled'
            )
            onPaymentDone()
          }
        }
        // Handle the response data here
      })
      .catch((error) => {
        // Handle any errors here
      })
  }

  let popup

  const handleAch = () => {
    popup = window?.open(
      achData.redirect_ach_url,
      '_blank',
      'width=600,height=600'
    )
    setAchData((prev) => ({ ...prev, redirect_ach_url: '' }))
    const timeout = () => {
      let timeOutInt = setTimeout(async () => {
        await checkPaymentProgress(achData?.trans_code)
      }, 10000)
      return () => clearTimeout(timeOutInt)
    }
    const interval = setInterval(() => {
      if (popup && popup.closed) {
        timeout()
        clearInterval(interval)
      }
    }, 2000)
    return () => {
      clearInterval(interval)
    }
  }

  const subType = paymentData?.updateSubscriptionType

  const UpdateType =
    subType === Strings.cancel
      ? 'Cancel Subscription'
      : subType === Strings.resume
        ? 'Resume Subscription'
        : subType === Strings.pause
          ? 'Pause Subscription'
          : Strings.updateMethod

  const isUpdatePayMethod = paymentData?.updateSubscription
    ? paymentData?.updateSubscriptionType === Strings.paymentMethod &&
      paymentData?.country_code !== 'IN'
      ? true
      : false
    : false

  const finalAmount = noCharge
    ? paymentData?.amount || 0
    : // : chargeData?.isPaymentGateWay
    // ? cardBrandSelect?.charge_object?.charges_obj?.final_amount ||0
    chargeData?.withChargeAmount

  // payment link summary still loading (header is already branded here)
  const renderLoader = () => {
    return <CheckoutSkeleton showHeader={false} showFooter={false} />
  }

  // branding is known by now; used while the Indian checkout is being opened
  const renderProcessing = () => {
    return (
      <div style={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
        <AautiPayLoader color={brand.loaderColor} text="Fetching details..." />
      </div>
    )
  }

  const renderModalView = () => {
    return (
      <>
        {paymentMethod?.length > 0 ? (
          <PricingBreakdown
            paymentRegionId={paymentRegionId}
            finalAmount={finalAmount}
            paymentData={paymentData}
            chargeData={chargeData}
            primaryColor={primaryColor}
            linearColorsName={linearColorsName}
            isGradientButton={isGradientButton}
            noCharge={noCharge}
            changeBtnText={pl_code ? (hasCustomBtnText ? changeBtnTextProp : 'Proceed') : changeBtnText}
            productDetails={productDetails}
            onClick={() => {
              if (isIndianPayment) {
                saveOrder(paymentMethod, chargeData)
              } else {
                setShowPaymentMethodModal(true)
              }
            }}
            currency_symbol={paymentRegionId?.currency_symbol}
            pl_code={pl_code}
            merchantName={merchantName}
            merchantLogo={merchantLogo}
            order_details={props?.order_details || paymentData?.order_details}
          />
        ) : (
          renderLoader()
        )}
      </>
    )
  }

  return (
    <Elements stripe={stripePromise}>
      {pageLoade ? (
        // details and the merchant's branding are not loaded yet
        <CheckoutSkeleton
          variant={pl_code && !paymentData?.updateSubscription ? 'summary' : 'paymentMethod'}
          showHeader={isHeaderShown}
        />
      ) :
        <div style={{ backgroundColor: themeColor }} className={styles.container}>
          {/* ─── Fixed Header ─── */}
          {(isHeaderShown || paySuccess) && (
            <BrandHeader text={brand.headerText} color={brand.headerColor} textColor={brand.headerTextColor} />
          )}

          {/* ─── Scrollable Middle Content ─── */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: paySuccess ? 'center' : 'flex-start', overflowY: paySuccess ? 'hidden' : 'auto', overflowX: 'hidden', minHeight: 0 }}>

            {paySuccess ? (
              <div style={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <PaymentStatus
                  primaryColor={primaryColor}
                  loaderColor={brand.loaderColor}
                  status={paySuccess}
                  message={failMessage}
                  sm={sm}
                  onFocusPopup={() => {
                    if (paymentPopupRef.current && !paymentPopupRef.current.closed) {
                      paymentPopupRef.current.focus()
                    }
                  }}
                  hasPopup={hasPopup}
                  onRetry={!hideFailActions ? () => {
                    setHideFailActions(false)
                    setPaySuccess(false)
                    setFailMessage('')
                    if (!chargeData?.auth_token) {
                      // Login never succeeded — retry login
                      getAccessToken()
                    } else if (!pl_code && isIndianPayment && !paymentData?.updateSubscription) {
                      // Normal Indian: re-trigger save-order + checkout
                      saveOrder(paymentMethod, chargeData)
                    }
                    // Payment link & overseas non-pl_code: reset to show the card view again
                  } : undefined}
                  onGoBack={!hideFailActions && !pl_code ? () => {
                    onCloseClick()
                    setHideFailActions(true)
                  } : undefined}
                />
              </div>
            ) : pl_code && !paymentData?.updateSubscription ? (
              renderModalView()
            ) : (
              <Grid
                container
                spacing={lg ? 1 : 2}
                style={{
                  padding: showHeader ? (lg ? '10px 10px' : '20px 20px') : 'unset',
                  height: '100%',
                  width: '100%',
                }}
                alignItems='flex-start'
              >
                {isIndianPayment && !pl_code && !paymentData?.updateSubscription ? (
                  /* Normal Indian payment (with id param) — auto save-order triggers, show loader */
                  renderProcessing()
                ) : isForUpdatePayDetails || isIndianPayment ? null : (
                  !isEmpty(paymentMethod) &&
                  <Grid item xs={12}>
                    {
                      isEmpty(paymentMethod) ? (
                        <div style={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                          <Typography style={{ fontSize: 20, fontWeight: 'bold' }}>
                            No Data
                          </Typography>
                        </div>
                      ) : (
                        <CardDetails
                          {...props}
                          isGradientButton={isGradientButton}
                          linearColorsName={linearColorsName}
                          onPaymentDone={onPaymentDone}
                          paymentMethod={paymentMethod}
                          paymentData={paymentData}
                          liveUrl={liveUrl}
                          activeIndex={activeIndex}
                          noCharge={noCharge}
                          primaryColor={primaryColor}
                          loaderColor={brand.loaderColor}
                          chargeData={chargeData}
                          setPaySuccess={(type, message, achDetails = {}) => {
                            setPaySuccess(type)
                            setFailMessage(message)
                            if (achDetails?.redirect_url && achDetails?.popup) {
                              // Navigate the pre-opened popup to the redirect URL
                              achDetails.popup.location.href = achDetails.redirect_url
                              paymentPopupRef.current = achDetails.popup
                              const transCode = achDetails?.code
                              const achPopup = achDetails.popup
                              const interval = setInterval(() => {
                                if (achPopup && achPopup.closed) {
                                  setHasPopup(false)
                                  paymentPopupRef.current = null
                                  setTimeout(async () => {
                                    await checkPaymentProgress(transCode)
                                  }, 10000)
                                  clearInterval(interval)
                                }
                              }, 2000)
                            } else if (achDetails?.redirect_url) {
                              // Fallback: try opening a new popup if no pre-opened one
                              const achPopup = window?.open(
                                achDetails.redirect_url,
                                '_blank',
                                'width=600,height=600'
                              )
                              if (achPopup) {
                                paymentPopupRef.current = achPopup
                                setHasPopup(true) // fallback path — popup just opened
                                const transCode = achDetails?.code
                                const interval = setInterval(() => {
                                  if (achPopup && achPopup.closed) {
                                    setHasPopup(false)
                                    paymentPopupRef.current = null
                                    setTimeout(async () => {
                                      await checkPaymentProgress(transCode)
                                    }, 10000)
                                    clearInterval(interval)
                                  }
                                }, 2000)
                              }
                            }
                            setAchData((prev) => ({
                              ...prev,
                              redirect_ach_url: '',
                              trans_code: achDetails?.code || '',
                            }))
                          }}
                          paymentSelectedType={paymentSelectedType}
                          setPaymentSelectedType={setPaymentSelectedType}
                          paymentMethodTabs={{ isCard, isBank, isOther }}
                          productDetails={productDetails}
                          pl_code={pl_code}
                          changeBtnText={changeBtnText}
                          currency_symbol={paymentRegionId?.currency_symbol}
                          gatewayName={gatewayName}
                          merchantName={merchantName}
                          merchantLogo={merchantLogo}
                          paymentRegionId={paymentRegionId}
                          setHasPopup={(popupWindow) => {
                            if (popupWindow) {
                              paymentPopupRef.current = popupWindow
                            }
                            setHasPopup(true)
                          }}
                        />
                      )}
                  </Grid>
                )}
              </Grid>
            )}
            <div>
              <Modal
                open={achData?.redirect_ach_url?.length > 0}
                onClose={() => console.log('iam called')}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: 10,
                }}
              >
                <Grid
                  item
                  style={{
                    maxWidth: 500,
                    maxHeight: 500,
                    minHeight: 200,
                    backgroundColor: 'white',
                    padding: 30,
                    borderRadius: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    flex={1}
                    flexGrow={1}
                    display={'flex'}
                    flexDirection='column'
                    alignItems='center'
                    justifyContent='center'
                  >
                    <Grid alignSelf={'center'} justifySelf={'center'}>
                      <Button
                        style={{ backgroundColor: primaryColor || '#0068EF', color: '#fff', borderRadius: 8, padding: '10px 24px' }}
                        onClick={handleAch}
                      >
                        <Typography fontSize={12} fontWeight={'bold'}>
                          {[Strings.startSub, Strings.updateMethod]?.includes(
                            achData?.payType
                          )
                            ? achData?.payType
                            : 'Continue to ACH'}
                        </Typography>
                      </Button>
                    </Grid>
                  </Box>
                  <Grid
                    display={'flex'}
                    flexDirection={'row'}
                    justifySelf={'flex-end'}
                    alignSelf={'center'}
                  >
                    <Grid
                      display='flex'
                      justifyContent='center'
                      alignItems='center'
                      bottom={10}
                      gap='4px'
                    >
                      <svg width='12' height='12' viewBox='0 0 24 24' fill='none'>
                        <rect x='3' y='11' width='18' height='11' rx='2' stroke='#8a96a8' strokeWidth='2' />
                        <path d='M7 11V7a5 5 0 0 1 10 0v4' stroke='#8a96a8' strokeWidth='2' strokeLinecap='round' />
                      </svg>
                      <Typography style={{ color: '#8a96a8', fontSize: 11 }}>Powered by{' '}</Typography>
                      <Typography style={{ fontWeight: 500, fontSize: 11, color: primaryColor || '#0068EF' }}>
                        AautiPay
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Modal>
            </div>

            {/* ─── Payment Method Modal for Overseas Payment Links ─── */}
            <Modal
              open={showPaymentMethodModal}
              onClose={(_, reason) => { if (reason !== 'backdropClick') setShowPaymentMethodModal(false) }}
              aria-labelledby='payment-method-modal'
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div style={{
                background: '#fff',
                borderRadius: 16,
                width: sm ? '95%' : 560,
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                outline: 'none',
              }}>
                {/* Modal header — centered title with close button */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px 20px', borderBottom: '1px solid #eef1f5', flexShrink: 0, position: 'relative' }}>
                  <Typography style={{ fontSize: 16, fontWeight: 600, color: '#1a1a2e' }}>
                    Payment method
                  </Typography>
                  <IconButton
                    onClick={() => setShowPaymentMethodModal(false)}
                    size="small"
                    style={{ color: '#8a96a8', position: 'absolute', right: 12 }}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </div>
                <div style={{ flex: 1, overflow: 'auto' }}>
                  <CardDetails
                    {...props}
                    modalMode={true}
                    isGradientButton={isGradientButton}
                    linearColorsName={linearColorsName}
                    onPaymentDone={onPaymentDone}
                    paymentMethod={paymentMethod}
                    paymentData={paymentData}
                    liveUrl={liveUrl}
                    activeIndex={activeIndex}
                    noCharge={noCharge}
                    primaryColor={primaryColor}
                    loaderColor={brand.loaderColor}
                    chargeData={chargeData}
                    setPaySuccess={(type, message, achDetails = {}) => {
                      setShowPaymentMethodModal(false)
                      setPaySuccess(type)
                      setFailMessage(message)
                      if (achDetails?.redirect_url && achDetails?.popup) {
                        achDetails.popup.location.href = achDetails.redirect_url
                        paymentPopupRef.current = achDetails.popup
                        const transCode = achDetails?.code
                        const achPopup = achDetails.popup
                        const interval = setInterval(() => {
                          if (achPopup && achPopup.closed) {
                            setHasPopup(false)
                            paymentPopupRef.current = null
                            setTimeout(async () => {
                              await checkPaymentProgress(transCode)
                            }, 10000)
                            clearInterval(interval)
                          }
                        }, 2000)
                      } else if (achDetails?.redirect_url) {
                        const achPopup = window?.open(
                          achDetails.redirect_url,
                          '_blank',
                          'width=600,height=600'
                        )
                        if (achPopup) {
                          paymentPopupRef.current = achPopup
                          setHasPopup(true)
                          const transCode = achDetails?.code
                          const interval = setInterval(() => {
                            if (achPopup && achPopup.closed) {
                              setHasPopup(false)
                              paymentPopupRef.current = null
                              setTimeout(async () => {
                                await checkPaymentProgress(transCode)
                              }, 10000)
                              clearInterval(interval)
                            }
                          }, 2000)
                        }
                      }
                      setAchData((prev) => ({
                        ...prev,
                        redirect_ach_url: '',
                        trans_code: achDetails?.code || '',
                      }))
                    }}
                    paymentSelectedType={paymentSelectedType}
                    setPaymentSelectedType={setPaymentSelectedType}
                    paymentMethodTabs={{ isCard, isBank, isOther }}
                    productDetails={productDetails}
                    pl_code={pl_code}
                    changeBtnText={changeBtnText}
                    currency_symbol={paymentRegionId?.currency_symbol}
                    gatewayName={gatewayName}
                    merchantName={merchantName}
                    merchantLogo={merchantLogo}
                    paymentRegionId={paymentRegionId}
                    setHasPopup={(popupWindow) => {
                      if (popupWindow) {
                        paymentPopupRef.current = popupWindow
                      }
                      setHasPopup(true)
                    }}
                  />
                </div>
              </div>
            </Modal>
          </div>

          {/* ─── Fixed Footer ─── */}
          <div style={{ flexShrink: 0 }}>
            {paySuccess === false && !isMobile && productDetails?.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: 16, padding: '8px 16px', flexWrap: 'wrap' }}>
                {productDetails.map((each) => (
                  <p
                    key={each?.id}
                    className={styles.gradientText}
                    style={{ cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                    onClick={() => window.open(each?.link)}
                  >
                    {each?.name}
                  </p>
                ))}
              </div>
            )}
            {/* Powered by */}
            <PoweredBy color={primaryColor || '#0068EF'} />
          </div>
        </div>}
    </Elements>
  )
}

export default PaymentAggregator
